import Modal from "@mui/material/Modal";
import {kModalStyles} from "../../../constants/styles";
import {kSystemIcons} from "../../../constants/icons";
import SystemScreenInfoHeader from "../../headers/SystemScreenInfoHeader";
import {kGamesImages} from "../../../constants/images";

export default function GamesScreenInfoDialog({open, handleClose}) {
    // Used through app screen headers to handle info about current
    // screen concept

    // BUILD
    return (
        <Modal open={open}
               onClose={handleClose}>
            <div className={kModalStyles.screenInfoDialogMediumStyle}>
                <SystemScreenInfoHeader handleClose={handleClose}
                                        icon={kSystemIcons.games}
                                        title={"Jeux éducatifs"} />
                {/** CONTENT */}
                <div className={"w-full flex justify-start items-start space-x-[32px] px-[24px] pt-[24px] pb-[16px]"}>
                    <div className={"w-[136px] min-w-[136px] mt-[8px]"}>
                        <img
                            className={"object-contain h-full w-full"}
                            src={kGamesImages.screenInfoImage}
                            alt="Les jeux éducatifs"
                        />
                    </div>
                    <div className={"w-full flex flex-col justify-start items-start"}>
                         <span className={"font-bold text-[18px] text-white -mt-[6px]"}>
                           {"Tu connais ton cours mais tu continues de faire des erreurs de calcul\u00A0?"}
                        </span>
                        <span className={"font-normal text-[14px] text-greyLight9 mt-[12px]"}>
                            {"Développe avec nos jeux, des réflexes quasi instinctifs sur les fondamentaux en calcul. Trouve un maximum de réponses justes en 1 minute, attention toute erreur entraîne la fin du jeu.\n À toi de jouer\u00A0!"}
                        </span>
                    </div>
                </div>
            </div>
        </Modal>
    );
}